// Generated by Melange

import * as Big from "./bindings/Big.js";

function plusMany(list) {
  if (list) {
    return Big.plus(list.hd, plusMany(list.tl));
  } else {
    return Big.fromFloat(0);
  }
}

function equals(a, b) {
  return Big.cmp(a, b) === 0;
}

function toFixed(precisionOpt, value) {
  const precision = precisionOpt !== undefined ? precisionOpt : 2;
  return Big.toFixed(value, precision, undefined);
}

const make = Big.fromFloat;

const fromString = Big.fromString;

const toString = Big.toString;

const fromInt = Big.fromInt;

const times = Big.times;

const plus = Big.plus;

const minus = Big.minus;

const compare = Big.cmp;

export {
  make,
  fromString,
  toString,
  fromInt,
  times,
  plus,
  plusMany,
  minus,
  compare,
  equals,
  toFixed,
}
/* Big Not a pure module */
